export default __webpack_public_path__ + "static/media/Invitation-Graphic.ee592dcd.jpg";